import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { User } from 'src/app/micro-services/user/models/user';
import { UserEleve } from 'src/app/micro-services/user/models/user-eleve';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { ClientService } from 'src/app/services/client-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-my-client',
  templateUrl: './my-client.component.html',
  styleUrls: ['./my-client.component.scss'],
})
export class MyClientComponent implements OnInit {
  coach : User;
  clients: User[] = [];
  filteredClients: User[] = [];
  client : UserEleve;
  searchTerm$ = new Subject<string>();
  constructor(
    private userService: UserService,
    private ApiProviderService : ApiProviderService,
    private router : Router,
    private clientService : ClientService
    ) { }

    ngOnInit(): void {
      this.clientService.clients$.subscribe(clients => {
        this.clients = clients;
        this.filteredClients = clients;
      });
    }


  getClientsByCoach() {
     this.ApiProviderService.getUsersByCoach(this.coach.id)
      .subscribe(
        (res: User[]) => {
          res.forEach(client => {
            if (client.isActive) {
              this.clients.push(client);
            }
          });
          this.filteredClients = this.clients
        },
        (err) => {
          console.error('Erreur lors de la recherche des clients :', err);
          this.clients = [];
        }
      );
  }

  goToClientPage(client: User) {
    try {
      this.client = client as UserEleve;
      this.userService.selectedClient = this.client;
      this.router.navigate(['/coach/client']);
    } catch (error) {
      // Gestion de l'erreur
      console.error('Une erreur s\'est produite lors de la navigation vers la page du client :', error);
      // Afficher un message d'erreur à l'utilisateur ou prendre d'autres mesures appropriées
    }
  }

  search(event: any): void {
    const searchTerm = event.detail.value;
    this.searchTerm$.next(searchTerm);
    this.filterClients(searchTerm)
  }

  filterClients(term: string): void {
    if (this.clients) {
      this.filteredClients = [];
      const addToFilteredClients = (clientToAdd: any) => {
        // Vérifier si le client n'est pas déjà présent dans filteredClients
        const isClientNotPresent = this.filteredClients.findIndex(
          (client) => client.id === clientToAdd.id
        ) === -1;
  
        if (isClientNotPresent) {
          this.filteredClients.push(clientToAdd);
        }
      };
  
      this.clients
        .filter(
          (client) =>
            client.userName?.toLowerCase().includes(term.toLowerCase())
        )
        .forEach((client) => {
          addToFilteredClients(client);
        });
  
      this.clients
        .filter((client) => client.name?.toLowerCase().includes(term.toLowerCase()))
        .forEach((client) => {
          addToFilteredClients(client);
        });
  
      this.clients
        .filter(
          (client) =>
            client.firstName?.toLowerCase().includes(term.toLowerCase())
        )
        .forEach((client) => {
          addToFilteredClients(client);
        });
    }
  }
}
